import React, { useState } from "react";

export default function WeatherTemperature(props) {
  const [unit, setUnit] = useState("metric");
  function showFahrenheit(event) {
    event.preventDefault();
    setUnit("imperial");
  }
  function showCelcius(event) {
    event.preventDefault();
    setUnit("metric");
  }
  if (unit === "metric") {
    return (
      <div className="weatherTemperature">
        <a href="/" onClick={showFahrenheit} className="changeUnitLink">
          Imperial
        </a>
        <div className="temperature">
          {Math.round(props.mainTemp)}
          <span className="unit">ºC</span>
        </div>
        <div className="temp-high-low">
          ↑{Math.round(props.highTemp)}º {"   "}↓{Math.round(props.lowTemp)}º
        </div>
      </div>
    );
  } else {
    let mainTempImperial = (props.mainTemp * 9) / 5 + 32;
    let highTempImperial = (props.highTemp * 9) / 5 + 32;
    let lowTempImperial = (props.lowTemp * 9) / 5 + 32;
    return (
      <div className="weatherTemperature">
        <a href="/" onClick={showCelcius} className="changeUnitLink">
          Metric
        </a>
        <div className="temperature">
          {Math.round(mainTempImperial)}
          <span className="unit">ºF</span>
        </div>
        <div className="temp-high-low">
          ↑{Math.round(highTempImperial)}º {"   "}↓{Math.round(lowTempImperial)}
          º
        </div>
      </div>
    );
  }
}
